import { Box, Button } from "@mui/material";

const SeeMoreTutors = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: "2rem",
        mb: { xs: "4rem", md: "3rem" },
      }}
    >
      <Button href="/get-started?seeMoreTutors=1">See more tutors</Button>
    </Box>
  );
};

export default SeeMoreTutors;
